export const translate: Record<string, string> = {
    views: 'lượt xem',
    'How you match this job': 'Mức độ phù hợp của bạn với công việc này',
    'You match this job': 'Bạn phù hợp với công việc này',
    'view detail': 'xem chi tiết',
    'Apply job': 'Nộp đơn',
    'View now': 'Xem ngay',
    Applied: 'Đã nộp đơn',
    'Save this job': 'Lưu công việc này',
    Saved: 'Đã lưu',
    Success: 'Thành công',
    'You have saved job, view': 'Bạn đã lưu việc làm thành công, xem',
    'My jobs': 'Việc làm của tôi',
    'Just removed 1 save job': 'Bạn vừa xóa 1 công việc',
    'Page link was copied!': 'Liên kết trang đã được sao chép',
    'Job description': 'Mô tả công việc',
    'Job requirements': 'Yêu cầu công việc',
    'What We Can Offer': 'Các phúc lợi dành cho bạn',
    'Job Information': 'Thông tin việc làm',
    'Job Locations': 'Địa điểm làm việc',
    'POSTED DATE': 'NGÀY ĐĂNG',
    'JOB FUNCTION': 'NGÀNH NGHỀ',
    'JOB INDUSTRY': 'LĨNH VỰC',
    'JOB LEVEL': 'CẤP BẬC',
    'PREFERRED LANGUAGE': 'NGÔN NGỮ TRÌNH BÀY HỒ SƠ',
    'YEAR OF EXPERIENCE': 'SỐ NĂM KINH NGHIỆM TỐI THIỂU',
    NATIONALITY: 'QUỐC TỊCH',
    'EDUCATION LEVEL': 'TRÌNH ĐỘ HỌC VẤN TỐI THIỂU',
    GENDER: 'GIỚI TÍNH',
    'AGE PREFERENCE': 'ĐỘ TUỔI MONG MUỐN',
    'MARITAL STATUS': 'TÌNH TRẠNG HÔN NHÂN',
    'NUMBER OF RECRUITS': 'SỐ LƯỢNG TUYỂN DỤNG',
    'WORKING DAYS': 'NGÀY LÀM VIỆC',
    'WORKING HOURS': 'GIỜ LÀM VIỆC',
    'WORKING TYPE': 'LOẠI HÌNH LÀM VIỆC',
    Vietnamese: 'Người Việt Nam',
    Foreigner: 'Người nước ngoài',
    Male: 'Nam',
    Female: 'Nữ',
    Single: 'Độc thân',
    Married: 'Đã kết hôn',
    SKILL: 'KỸ NĂNG',
    'Not required': 'Không yêu cầu',
    'Not shown': 'Không hiển thị',
    Any: 'Bất kỳ',
    'User tags': 'Từ khoá',
    'View more': 'Xem thêm',
    '/companies': '/nha-tuyen-dung',
    '/job-search': '/tim-viec-lam',
    Home: 'Trang chủ',
    Jobs: 'Việc làm',
    employee: 'nhân viên',
    'my-profile': 'ho-so',
    'VietnamWorks profile': 'Hồ sơ VietnamWorks',
    Recruiting: 'Tuyển',
    at: 'tại',
    'Competitive rate': 'Tỷ lệ cạnh tranh',
    'VietnamWorks calculates your competitive rate based on your application information and compares it with other candidates for this job after you apply.':
        ' VietnamWorks tính toán tỷ lệ cạnh tranh của bạn dựa trên thông tin ứng tuyển của bạn và so sánh nó với các ứng viên khác cho công việc này sau khi bạn ứng tuyển.',
    'Stay ahead of the competition by maintaining a strong competitive rate through regular updates':
        'Hãy giữ vị trí dẫn đầu trong số các ứng cứ viên khác bằng cách duy trì tỷ lệ cạnh tranh cao thông qua việc cập nhật thường xuyên',
    'Jobs from this company': 'Việc làm cùng công ty',
    'Company culture page': 'Trang Văn hóa công ty',
    'Employer highly values your resume and has sent you an invitation to apply.': 'Nhà tuyển dụng đánh giá cao hồ sơ của bạn và đã gửi lời mời ứng tuyển.',
    'View full job description': 'Xem đầy đủ mô tả công việc',
    Negotiable: 'Thương lượng',
    'You will be redirect to Employer website':
        'Bạn sẽ được chuyển đến trang web của nhà tuyển dụng',
    'Accept invitation': 'Chấp nhận lời mời',
    'Information of this employer is hidden for confidentiality purposes.':
        'Thông tin nhà tuyển dụng đã được ẩn đi vì mục đích bảo mật.',
    Matching: 'Phù hợp',
    'Highly matching': 'Rất phù hợp',
    'Not matching': 'Chưa phù hợp',
    'Not enough data': 'Chưa đủ dữ liệu',
    'View matching score': 'Xem mức độ phù hợp',
    'Applied for this job': 'Đã nộp đơn việc làm này',
    'View application status': 'Xem trạng thái hồ sơ',
    'View analysis': 'Xem phân tích',
    'my-career-center/my-jobs': 'quan-ly-nghe-nghiep/viec-lam-cua-toi',
    'Log in to view': 'Đăng nhập để xem',
    'Similar jobs': 'Việc làm tương tự',
    'View map': 'Xem bản đồ',
    Close: 'Đóng',
    'Do you want to see your competitive analysis?': 'Bạn muốn phân tích CV trước khi ứng tuyển?',
    'View competitive analysis before applying': 'Xem phân tích mức độ cạnh tranh trước khi ứng tuyển',
    'View competitive analysis': 'Xem phân tích mức độ cạnh tranh',
    'Competitive Analysis': 'Phân tích mức độ cạnh tranh',
    'What percentage are you suitable for this position?': 'Bạn phù hợp bao nhiêu % cho vị trí này?',
    'What is your ranking compared to other applicants?': 'Bạn xếp hạng Top bao nhiêu so với những hồ sơ ứng tuyển?',
    'What is the market salary for similar positions?': 'Thị trường đang trả mức lương bao nhiêu cho vị trí tương tự?',
    'Is the demand for this position on the market high or low?': 'Nhu cầu tuyển dụng cho vị trí này trên thị trường cao hay thấp?',
    'Trial price': 'Giá dùng thử',
    'View analysis now': 'Xem đánh giá ngay',
    '/cv-review' : '/phan-tich-ho-so',
    'See report': 'Xem đánh giá',
    'Evaluated on': 'Đánh giá',
    'Matching rate to job requirements': 'Độ phù hợp với công việc',
    'Comparison with other applicants': 'So với ứng viên khác',
    'Evaluate another CV': 'Đánh giá hồ sơ khác',
    'You can use this feature multiple times with different CVs.': 'Bạn có thể sử dụng tính năng này nhiều lần với nhiều CV khác nhau.',
    'time': 'lượt',
    'High':	'Cao',
    'Low':	'Thấp',
    'Medium': 'Trung bình',
    'Very high': 'Rất cao',
    'Rank': 'Xếp hạng',
    'Try for free': 'Dùng thử miễn phí',
    'You have {0} free trial': 'Bạn có {0} lần dùng thử miễn phí',
    'Price': 'Giá'
 
}
